module.exports = __webpack_public_path__ + "img/06.a07e7446.jpg";